/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Find_BodyInputs */

const en_portal_step_find_body = /** @type {(inputs: Portal_Step_Find_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open their page and see what they offer, what it costs and when they are free.`)
};

const pl_portal_step_find_body = /** @type {(inputs: Portal_Step_Find_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz stronę trenera, zobacz jego usługi, ceny i wolne terminy.`)
};

/**
* | output |
* | --- |
* | "Open their page and see what they offer, what it costs and when they are free." |
*
* @param {Portal_Step_Find_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_find_body = /** @type {((inputs?: Portal_Step_Find_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Find_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_find_body(inputs)
	return en_portal_step_find_body(inputs)
});